/* eslint import/no-unresolved: 0 */
let root;
if (typeof global !== 'undefined') root = global;
else if (typeof window !== 'undefined') root = window;
else root = {};

(function (window) {
  'use strict';

  // util
  window.moment = require('moment');
  window.locale = require('../etc/moment');
  window._ = require('lodash');
  window.Promise = require('bluebird');
  window.fetch = require('isomorphic-fetch');
  window.queryString = require('querystring');


  // jQuery
  window.$ = window.jQuery = require('jquery');
  require('jquery-serializejson');
  // require('materialize-css/dist/js/materialize.js');
  require('jquery.scrollto');

  // riot
  window.riot = require('riot');
  window.riot.route = require('riot-route');
  // window.redux = require('redux');

  // slick
  require('slick-carousel');
  require('slick-lightbox');

  // selectize
  window.Selectize = require('selectize');

  // tether
  window.Tether = require('tether');
  window.Drop = require('tether-drop');

  // swiper
  window.Swiper = require('swiper');

  // scrollmagic
  window.ScrollMagic = require('scrollmagic');

  // clipboard
  window.Clipboard = require('clipboard');

  // autosize
  window.autosize = require('autosize');

  // SmoothScroll
  window.SmoothScroll = require('smooth-scroll');

  // gumshoe
  window.gumshoe = require('gumshoejs');

  // cookie
  window.Cookie = require('js-cookie');

  // jQuery Modal
  window.Modal = require('jquery-modal');
  // Parsley.js
  window.Parsley = require('parsleyjs');
  require('../../../node_modules/parsleyjs/dist/i18n/th');
  // Store.js
  window.Store = require('store');
  // jwt-decode
  window.jwtDecode = require('jwt-decode');

  // numeral
  window.numeral = require('numeral');

  // d3
  window.d3 = require('d3');
  const d3_legend = require('d3-svg-legend');
  window._.merge(window.d3, d3_legend);
}(root));
